import { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import { Skeleton } from "primereact/skeleton";
import { useNavigate } from "react-router-dom";

import ScheduledCampaignCalender from "./charts/ScheduledCalender";
import MailStatCard from "./MailStatCard";
import ClientPiechart from "./charts/ClientPiechart";
import TopPerformingContent from "./charts/TopPerformingCard";
import CampaignStatCard from "./CampaignStatCard";

const CampaignDashboard = () => {
  const [clientsData, setClientsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedClients, setSelectedClients] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const campaigns = [
      {
        id: 1,
        campaignName: "Unusual sign-in activity..",
    clientName: "SecurityHorizon.com",
        status: "Active",
        createdDate: "20/03/2025",
        emailsSent: 500,
        clickRate: "30%",
        successRate: "10%",
      },
      {
        id: 2,
        campaignName: "Your password is expiring",
         clientName: "SecurityHorizon.com",
        status: "Active",
        createdDate: "20/03/2025",
        emailsSent: 500,
        clickRate: "30%",
        successRate: "10%",
      },
      {
        id: 3,
        campaignName: "Invoice attached",
        clientName: "SecurityHorizon.com",
        status: "Inactive",
        createdDate: "20/03/2025",
        emailsSent: 300,
        clickRate: "20%",
        successRate: "15%",
      },
      {
        id: 4,
        campaignName: "Claim your refund",
         clientName: "SecurityHorizon.com",
        status: "Active",
        createdDate: "20/03/2025",
        emailsSent: 800,
        clickRate: "40%",
        successRate: "25%",
      },
      {
        id: 5,
        campaignName: "Action required: Confirm ..",
        clientName: "SecurityHorizon.com",
        status: "Inactive",
        createdDate: "20/03/2025",
        emailsSent: 250,
        clickRate: "18%",
        successRate: "8%",
      },
      {
        id: 6,
        campaignName: "Bank Alerts",
        clientName: "SecurityHorizon.com",
        status: "Active",
        createdDate: "20/03/2025",
        emailsSent: 900,
        clickRate: "50%",
        successRate: "30%",
      },
    ];

    setTimeout(() => {
      setClientsData(campaigns);
      setLoading(false);
    }, 1000);
  }, []);

  /* Status badge */
  const statusTemplate = (rowData) => (
    <span
      className={`font-semibold ${
        rowData.status === "Active"
          ? "text-green-600"
          : "text-red-500"
      }`}
    >
      {rowData.status}
    </span>
  );

  /* Action buttons */
const actionTemplate = () => (
  <div className="flex justify-center items-center">
    <FaTrashAlt className="text-red-500 cursor-pointer text-lg" />
  </div>
);

  /* Skeleton rows */
  const skeletonRows = Array.from({ length: 5 }).map((_, i) => ({
    id: i,
    campaignName: <Skeleton width="12rem" />,
    clientName: <Skeleton width="8rem" />,
    status: <Skeleton width="6rem" />,
    createdDate: <Skeleton width="8rem" />,
    emailsSent: <Skeleton width="6rem" />,
    clickRate: <Skeleton width="6rem" />,
    successRate: <Skeleton width="6rem" />,
    actions: <Skeleton width="4rem" />,
  }));

  return (
    <div className="w-full  pt-3 md:pt-2 mb-6">
      {/* Stat Cards */}
      <CampaignStatCard />
      <MailStatCard />

      {/* Charts */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-2">
        <ClientPiechart />
        <TopPerformingContent />
        <ScheduledCampaignCalender />
      </div>

      {/* Table Header */}
      <div className="flex justify-between items-center my-3">
        <h5 className="text-lg  text-slate-800 dark:text-slate-200">
          Recent Campaigns
        </h5>
      </div>

      {/* Table */}
      <div className="overflow-x-auto">
        <DataTable
          value={loading ? skeletonRows : clientsData}
          selection={selectedClients}
          onSelectionChange={(e) => setSelectedClients(e.value)}
          selectionMode="checkbox"
          dataKey="id"
          responsiveLayout="scroll"
          className="custom-table"
          style={{ minWidth: "1440px" }}
        >
          <Column selectionMode="multiple" style={{ width: "3rem" }} />
          <Column field="campaignName" header="Campaign Name"  sortable />
          <Column field="clientName" header="Client Name" sortable />
          <Column
            field="status"
            header="Status"
            body={statusTemplate}

          />
          <Column field="createdDate" header="Created Date" />
          <Column field="emailsSent" header="Emails Sent"  />
          <Column field="clickRate" header="Click Rate" />
          <Column field="successRate" header="Success Rate" />
          <Column
            header="Actions"
            body={
              loading
                ? () => <Skeleton width="4rem" />
                : actionTemplate
            }
            style={{ minWidth: "100px" }}
              headerStyle={{ textAlign: "center" }}
  bodyStyle={{ textAlign: "center" }}
          />
        </DataTable>
      </div>
    </div>
  );
};

export default CampaignDashboard;